"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _BrandDetailsProvider = require("../context/BrandDetailsProvider");

var useBrandDetails = function useBrandDetails() {
  var context = (0, _react.useContext)(_BrandDetailsProvider.BrandDetailsContext);

  if (context === undefined) {
    throw new Error('useBrandDetails requires a BrandDetailsProvider as a parent wrapper.');
  }

  return context;
};

var _default = useBrandDetails;
exports["default"] = _default;